<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24" fill="none">
    <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'CheckIcon'
}
</script>

<style scoped>
.icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  margin-top: 2px;
  flex-shrink: 0;
}
</style> 